import {
  HTMLElement,
  append,
  cloneNode,
  closest,
  createDiv,
  createTemplate,
  floor,
  loadImage,
  removeChildNodes,
  sizeOfArray,
  toggleClass,
  whenAll,
} from '@acng/frontend-bounty';
import {livecamFeature} from '../config/feature.js';
import {connectPopupController, createPerceptiveHTML} from '@acng/frontend-discovery';
import {createStream} from '@acng/frontend-relativity';
import {inject} from 'acng/core/service/ng.js';
import {tileFeature} from 'acng/core/config/feature.js';
import {ctxAmateur} from 'acng/amateurPool/context/amateur.js';
import {ignoreClicks} from 'acng/amateurPool/tiles/AmateurTile.js';
import {shuffle} from 'acng/core/factory/helper.js';

const WARP = Symbol();
/**
 * @type {WeakMap<object, import('angular').IScope>}
 */
const scopes = new WeakMap();

livecamFeature.defineElementLoader('onsw-livecams-sidebar', async (localName) => {
  const [smallTemplate, largeTemplate] = await whenAll([
    tileFeature.lookup('livecamTile'),
    tileFeature.lookup('tileAmateur'),
  ]);
  const Amateur = inject('Amateur');
  const $rootScope = inject('$rootScope');
  const $compile = inject('$compile');
  const Livecam = inject('Livecam');

  ctxAmateur.subscribeTagName(localName);

  return class extends HTMLElement {
    connectedCallback() {
      ctxAmateur.observe(this, (sedcard) => {
        this[WARP]?.disconnect();
        removeChildNodes(this);
        toggleClass(this, 'not-sedcard', !sedcard);

        this[WARP] = createPerceptiveHTML(
          this,
          createStream([], async () => {
            const list = await Livecam.list();

            // (Staging) fallback
            if (list.length < 12) {
              return inject('AmateurFilter').get('livecam_shuffle').list(20000);
            }

            const result = list.filter((id) => id != sedcard?.id);
            shuffle(result, floor(sizeOfArray(result) * 2 / 3));
            return result;
          }),
          async (amateurId, loader) => {
            // First the async stuff
            const amateur = await Amateur.get(amateurId);
            const [image, from] = await whenAll([
              await loadImage(amateur.getImageUrl('800')),
              await amateur.getLocation(),
            ]);

            if (!loader.target) {
              return;
            }

            /*
          const rendered = (sedcard ? largeTemplate : smallTemplate).render({
            nickname: amateur.getNickname(),
            click: () => amateur.goto(),
          });
          */
            const rendered = cloneNode(sedcard ? largeTemplate : smallTemplate);

            const box = /** @type {HTMLElement} */ (rendered.content.firstElementChild);
            const div = createDiv();
            append(div, box);
            ctxAmateur.provide(box, amateur);
            connectPopupController(box);

            box.style.setProperty('background-image', `url(${image.src})`);
            box.setAttribute('ng-click', 'click($event)');

            // These templates require angular
            const $scope = $rootScope.$new();
            scopes.set(loader, $scope);
            Object.assign($scope, {
              amateur,
              nickname: amateur.getNickname(),
              age: amateur.age,
              from,
              click: /** @param {Event} ev */ (ev) => {
                if (closest(ev.target, ignoreClicks, undefined, box)) {
                  return;
                }
                amateur.goto();
              },
              desc: amateur.getDescription(),
            });
            $compile(div)($scope);
            $scope.$digest();

            return createTemplate('', div);
          },
          (loader) => scopes.get(loader)?.$destroy()
        );

        this[WARP].connect();
      });
    }

    disconnectedCallback() {
      this[WARP]?.disconnect();
    }
  };
});
